import { useEffect, useState } from 'react';
import { urls } from '@zapier/identity-utils';

import { fetch } from '../../utils';

type CurrentUserResult = {
  id: string | number;
  email: string;
};

export function useCurrentUser() {
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState<CurrentUserResult | null>();

  useEffect(() => {
    async function getCurrentSession() {
      const results = await fetch<CurrentUserResult>(urls.CURRENT_SESSION_URL);

      setIsLoading(false);
      setCurrentUser(results.body);
    }

    getCurrentSession();
  }, []);

  return {
    currentUser,
    isLoading,
  };
}
